import { apiFetch } from '../api-client';

export interface PublicTenant {
  id: string;
  name: string;
  slug: string;
  defaultLocale: string;
  enabledLocales: string[];
}

/**
 * Whether a coordinate is inside a city's service area.
 *
 * `hasServiceArea: false` means the city has no boundary drawn and
 * accepts every location — it is NOT a refusal, and a caller that treats
 * it as one blocks reporting in every city we have not drawn yet.
 */
export interface ServiceAreaCheck {
  covered: boolean;
  hasServiceArea: boolean;
}

export const publicTenantsApi = {
  list(): Promise<PublicTenant[]> {
    return apiFetch<PublicTenant[]>('/public/tenants');
  },
  covers(tenantId: string, latitude: number, longitude: number): Promise<ServiceAreaCheck> {
    return apiFetch<ServiceAreaCheck>(
      `/public/tenants/${encodeURIComponent(tenantId)}/covers?lat=${latitude}&lng=${longitude}`,
    );
  },
};
